const initState = {
    connections: [],
    partners: [],
    pendingPartners: [],
    isLoading: true
}

export const SET_CONNECTIONS = "connectionsReducer_SET_CONNECTIONS"
export const SET_PARTNERS = "connectionsReducer_SET_PARTNERS"
export const SET_PENDING_PARTNERS = "connectionsReducer_SET_PENDING_PARTNERS"
export const UPDATE_PARTNER = "connectionsReducer_UPDATE_PARTNER"
export const SET_LOADING = "connectionsReducer_SET_LOADING"

const connectionsReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case SET_CONNECTIONS:
            return {
                ...state,
                connections: action.connections
            }
        case SET_PARTNERS:
            return {
                ...state,
                partners: action.partners
            }
        // case SET_PENDING_PARTNERS:
        //     return {
        //         ...state,
        //         pendingPartners: action.pendingPartners
        //     }
        case UPDATE_PARTNER:
            return {
                ...state,
                partners: state.partners.map(item => {
                    if (item.id === action.partner.id) {
                        return action.partner
                    }
                    return item
                })
            }
            // console.log('action partner: ', action.partner)
            // const partnerIndex = state.partners.findIndex((val) => val?.id === action?.partner?.id)
            // if (partnerIndex) {
            //     console.log('FOUND INDEX')
            //     state.partners[partnerIndex] = action.partner
            //     return state
            // }
            // console.log('NOT FOUND INDEX')
            // console.log('partners: ', state.partners)
            // return {
            //     ...state,

            // }
        // case ADDED_NEW_CLIENT:
        //     return {
        //         ...state,
        //         clients: state.clients.concat(action.newClient)
        //     }
        // case SET_CLIENTS:
        //     return {
        //         ...state,
        //         clients: action.clients
        //     }
        // case SET_CLIENTS_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.isLoading
        //     }
        // case SET_CLIENTS_SAVING:
        //     return {
        //         ...state,
        //         isSaving: action.isSaving
        //     }
        // case SET_CLIENTS_SAVING_ERROR:
        //     return {
        //         ...state,
        //         savingError: action.savingError
        //     }
        default:
            break;
    }

    return state
}

export default connectionsReducer;